import { Injectable } from "@angular/core";
@Injectable()
export class AgencyDto {
    id: string;
    name: string;
    strAddr: string;
    city: string;
    state: string;
    zip: string;
    contact: string;
    phone: string;
    altPhone: string;
    fax: string;
    email: string;
    addrUnit: string;
}
